import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'notification'];

  connect() {
    this.timeout = null;
  }

  show() {
    this.containerTarget.classList.remove('translate-x-full', 'opacity-0');
    this.containerTarget.classList.add('translate-x-0', 'opacity-100', 'right-24');

    this.timeout = setTimeout(() => {
      this.dismiss();
    }, 5000);
  }

  dismiss(e) {
    if (this.hasNotificationTarget) {
      this._hideNotification(this.notificationTarget);
    }
  }

  _hideNotification (el) {
    el.remove()
    el.addEventListener('transitionend', () => el.remove())
    setTimeout(() => {
      el.classList.remove('fade-in')
      el.classList.add('fade-out')
    }, 3)
  }
}
